import { Timestamp } from '@britishcouncil/common-core';
import {
  EorSpeakingMonitoringReportResponse,
  PagedResultOfEorSpeakingMonitoringReportResponse,
  api,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { EorSpeakingMonitoringFilterType } from './eorSpeakingMonitoringReportTypes';
import { getPaginationParameters, getQueryStringParameters } from 'utils';

type ReportParams = TableState<
  EorSpeakingMonitoringReportResponse,
  EorSpeakingMonitoringFilterType
>;

const mapQueryParams = (params: ReportParams) => {
  if (params.filters.date?.[0] == undefined || params.filters.date[1] == undefined) {
    throw new Error('From and To dates are required');
  }

  return {
    ...getPaginationParameters(params),
    filter: {
      monitoringReason: params.filters.monitoringReason ?? [],
      monitoringResult: params.filters.monitoringResult ?? [],
      monitoringStage: params.filters.monitoringStage ?? [],
      monitoringType: params.filters.monitoringType ?? [],
      startDate: Timestamp.toISOString(params.filters.date[0]),
      endDate: Timestamp.toISOString(params.filters.date[1]),
    },
  };
};

export const eorSpeakingMonitoringReportApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getEorSpeakingMonitoringReportRecords: builder.query<
      PagedResultOfEorSpeakingMonitoringReportResponse,
      ReportParams
    >({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.eorSpeakingMonitoringReport.getEorSpeakingMonitoringReport(input);
      },
    }),
    generateEorSpeakingMonitoringPdfReport: builder.mutation<File, ReportParams>({
      query: async (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.eorSpeakingMonitoringReport.getEorSpeakingMonitoringPdfReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
    generateEorSpeakingMonitoringExcelReport: builder.mutation<File, ReportParams>({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.eorSpeakingMonitoringReport.getEorSpeakingMonitoringExcelReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
  }),
});

export const {
  useGetEorSpeakingMonitoringReportRecordsQuery,
  useGenerateEorSpeakingMonitoringPdfReportMutation,
  useGenerateEorSpeakingMonitoringExcelReportMutation,
} = eorSpeakingMonitoringReportApi;
